<template>
  <div class="container">
    <Breadcrumbs :items="breadcrumbs" />
    <section class="py-8 md:py-20">
      <h1 class="lg:block font-light text-2xl md:text-4xl mb-8 md:mb-20">
        Privacy
      </h1>
      <div
        class="space-y-16 md:space-y-10 lg:flex lg:flex-wrap lg:gap-y-32 lg:space-y-0 lg:-mx-8"
      >
        <div
          v-for="(card, i) in cards"
          :key="i"
          class="px-8 md:flex lg:w-1/2 md:gap-16"
        >
          <div class="mb-8 md:w-1/2 md:mb-0">
            <NuxtImg :src="`/assets/img/${card.img}`" />
          </div>
          <div
            class="md:w-1/2 md:py-1.6 md:flex md:flex-col md:justify-between"
          >
            <p class="font-bold uppercase text-xl mb-16 md:mb-2">
              {{ card.title }}
            </p>
            <UcrsAnchor
              :to="card.href"
              label="Approfondisci"
              :animation="true"
            />
          </div>
        </div>
      </div>
      <div class="lg:flex lg:space-x-24 space-y-8 lg:space-y-0 mt-20 lg:mt-32">
        <a
          v-for="(link, i) in links"
          :key="i"
          :href="link.href"
          target="_blank"
          class="flex items-center"
        >
          <SvgIcon name="download" class="text-gray max-w-11 max-h-11 mr-6" />
          <span
            class="text-black-light text-sm lg:text-lg"
            v-text="link.text"
          ></span>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
// Components
import Breadcrumbs from '~/components/Breadcrumbs.vue'
import UcrsAnchor from '~/components/UcrsAnchor.vue'

export default {
  components: { Breadcrumbs, UcrsAnchor },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'La mia Homepage',
          href: '/area-riservata/dashboard',
        },
        {
          text: 'Privacy',
        },
      ],
      cards: [
        {
          img: 'ucrs-informativa-clientela.jpg',
          title: 'Informativa privacy per la clientela',
          href: '/privacy/informativa-per-la-clientela',
        },
        {
          img: 'ucrs-informativa-sito-web.jpg',
          title: 'Informativa relativa al sito web',
          href: '/privacy/informativa-relativa-sito-web',
        },
      ],
      links: [
        {
          href: '/assets/pdf/Allegato12ModuloEserciziodeiDiritti.pdf',
          text: 'Scarica il modulo esercizio dei Diritti',
        },
        {
          href: '/assets/pdf/Elenco_Responsabili_Esterni_2_2023.pdf',
          text: 'Elenco Terzi Responsabili',
        },
        {
          href:
            '/assets/pdf/Elenco_dei_soggetti_a_cui_i_dati_possono_essere_comunicati.pdf',
          text: 'Elenco dei soggetti a cui i dati possono essere comunicati',
        },
        {
          href:
            '/assets/pdf/USC121-InformativaAPPUniCreditRes-ed05_2022_v2_def.pdf',
          text: 'Informativa privacy APP PLUS',
        },
      ],
    }
  },
  head() {
    return {
      title: 'Privacy - UniCredit RE Services',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Area riservata | Privacy - UniCredit RE Services',
        },
      ],
    }
  },
}
</script>
